import axios from 'axios';

const SIGHTSEEING_PAGE_SIZE = 9;

export async function fetchAllSightseeingForIso(backendUrl: string | undefined, iso: string, signal: AbortSignal): Promise<any[]> {
  const collectedPosts: any[] = [];
  let cursor = '';
  let cursorToken = '';
  let guard = 0;

  while (guard < 500) {
    const cursorQuery = cursor ? `&cursor=${encodeURIComponent(cursor)}&cursor_token=${encodeURIComponent(cursorToken)}` : '';
    const response = await axios.get(`${backendUrl}/worlddata/sightseeing/get-sightseeing-data/${SIGHTSEEING_PAGE_SIZE}/?iso=${encodeURIComponent(iso)}${cursorQuery}`, { signal });

    const items = Array.isArray(response.data?.items) ? response.data.items : [];
    collectedPosts.push(...items);
    cursorToken = String(response.data?.cursor_token || cursorToken || '');

    const nextCursorRaw = response.data?.old_cursor;
    const nextCursor = nextCursorRaw === null || nextCursorRaw === undefined ? '' : String(nextCursorRaw);

    if (!nextCursor || items.length === 0 || nextCursor === cursor) {
      break;
    }

    cursor = nextCursor;
    guard += 1;
  }

  return collectedPosts;
}

export async function fetchSightseeingCursor(
  backendUrl: string | undefined,
  postId: number,
  iso: string,
): Promise<{ cursor: string; cursorToken: string }> {
  const cursorResponse = await axios.get(`${backendUrl}/worlddata/sightseeing/get-cursor-for-item/${postId}/${SIGHTSEEING_PAGE_SIZE}/?iso=${iso}`);
  return {
    cursor: String(cursorResponse.data?.cursor || ''),
    cursorToken: String(cursorResponse.data?.cursor_token || ''),
  };
}
